import { useEffect, useRef, useState } from "react";
import "./App.css";
import SalesTologyFooter from "./components/SalesTologyFooter/SalesTologyFooter";
import Navbar from "./components/Navbar/Navbar";
import EmailVerificationModal from "./components/OTPModal/EmailVerificationModal";

function Survey() {
  const currentDate = new Date().toLocaleDateString("en-GB");
  const [roles, setRoles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [activeDivision, setActiveDivision] = useState(55);
  const [activeRole, setActiveRole] = useState(1);
  const [answers, setAnswers] = useState([]);
  const [questions, setQuestions] = useState([]);
  const [questionsList, setQuestionsList] = useState([]);
  const [successMessage, setSuccessMessage] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [divisionName, setActiveDivisionName] = useState("Role Clarity");
  const [divisions, setDivisions] = useState([]);
  const [roleName, setRoleName] = useState("Sales Leader");
  const [email, setEmail] = useState("");
  const [startDate, setStartDate] = useState(null);
  const [salesLeader, setSalesLeader] = useState(0);
  const [salesManager, setSalesManager] = useState(0);
  const [salesProfessional, setSalesProfessional] = useState(0);
  const [summaryData, setSummaryData] = useState({
    Email: "",
    Sales_Leader: 0,
    Sales_Manager: 0,
    Sales_Professional: 0,
  });
  const debounceTimer = useRef(null);
  const [resultSummaryData, setResultSummaryData] = useState(null);
  const [completedDivisions, setCompletedDivisions] = useState([]);
  const [showEmailError, setShowEmailError] = useState(false);
  const emailSectionRef = useRef(null);

  const [isVerificationModalOpen, setIsVerificationModalOpen] = useState(true);
  const [isEmailVerified, setIsEmailVerified] = useState(false);

  // New state for role switch confirmation
  const [showRoleSwitchModal, setShowRoleSwitchModal] = useState(false);
  const [pendingRole, setPendingRole] = useState(null);

  // Helper function to extract role IDs from the new format
  const getQuestionRoleIds = (question) => {
    return question.Question_Roles?.map((qr) => qr.Role_Id) || [];
  };

  // Helper function to extract division IDs from the new format
  const getQuestionDivisionIds = (question) => {
    return question.Question_Divisions?.map((qd) => qd.Division_Id) || [];
  };

  const fetchSurveyResultSummary = async (email) => {
    try {
      const response = await fetch(
        `${API_BASE_URL}/survey-results/get_result_summary?email=${encodeURIComponent(
          email
        )}`
      );

      if (response.ok) {
        const resultSummaryData = await response.json();
        console.log("Survey Result Summary:", resultSummaryData);

        if (resultSummaryData.success && resultSummaryData.data) {
          setResultSummaryData(resultSummaryData.data);
        }

        return resultSummaryData;
      } else {
        console.error(
          "Failed to fetch survey result summary:",
          response.status
        );
        return null;
      }
    } catch (error) {
      console.error("Error fetching survey result summary:", error);
      return null;
    }
  };

  const handleVerificationSuccess = async (verifiedEmail) => {
    console.log("verifiedEmail", verifiedEmail);
    setEmail(verifiedEmail);
    setIsEmailVerified(true);
    setIsVerificationModalOpen(false);

    const resultSummary = await fetchSurveyResultSummary(verifiedEmail);

    if (resultSummary) {
      console.log("Processing result summary:", resultSummary);
    }
  };

  console.log("role...", roleName);
  const getDivision = (divisionId) => {
    return divisions.filter((item) => item.Division_Id == divisionId);
  };

  const getRole = (roleId) => {
    return roles.filter((item) => item.Role_Id == roleId);
  };

  const API_BASE_URL =
    // process.env.REACT_APP_API_BASE_URL || "http://184.73.15.70:4000/api";
    process.env.REACT_APP_API_BASE_URL || "https://api.salestology.com/api";

  useEffect(() => {
    fetch(`${API_BASE_URL}/questions`)
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then((data) => {
        setQuestionsList(data);
      })
      .catch((error) => {
        console.error("There was a problem with the fetch operation:", error);
      });
  }, []);

  console.log("division ....", activeDivision);

  const handleSelect = (question, option) => {
    if (startDate == null) {
      setStartDate(new Date());
    }

    setAnswers((prev) => {
      // Get role IDs from the new question format
      const questionRoleIds = getQuestionRoleIds(question);
      const matchingRoles = roles.filter((role) =>
        questionRoleIds.includes(role.Role_Id)
      );

      // Get division IDs from the new question format
      const questionDivisionIds = getQuestionDivisionIds(question);
      let matchingDivisions = matchingRoles.flatMap((role) =>
        role.Divisions.filter((division) =>
          questionDivisionIds.includes(division.Division_Id)
        )
      );

      const orderedRoles = [
        ...matchingRoles.filter((role) => role.Role_Name === "Role Clarity"),
        ...matchingRoles.filter(
          (role) => role.Role_Name === "Performance Management"
        ),
        ...matchingRoles.filter(
          (role) =>
            role.Role_Name !== "Role Clarity" &&
            role.Role_Name !== "Performance Management"
        ),
      ];

      const orderedRoleNames = orderedRoles
        .map((role) => role.Role_Name)
        .join(", ");
      const divisionNames = matchingDivisions
        .map((division) => division.Division_Name)
        .join(", ");

      const existingIndex = prev.findIndex(
        (item) =>
          item.question === question.Question && item.division === divisionNames
      );

      const newEntry = {
        division: divisionNames,
        question: question.Question,
        response: option.toString(),
      };

      if (existingIndex !== -1) {
        return prev.map((item, index) =>
          index === existingIndex
            ? { ...item, response: option.toString() }
            : item
        );
      } else {
        return [...prev, newEntry];
      }
    });
  };

  useEffect(() => {
    fetch(`${API_BASE_URL}/roles`)
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        setRoles(data);
        setActiveRole(data[0].Role_Id);
        setDivisions(data[0].Divisions);
      })
      .catch((err) => {
        setError(err.message);
      });
  }, []);

  useEffect(() => {
    if (questionsList.length > 0) {
      // Filter questions based on the new format
      const matchedQuestions = questionsList.filter((question) => {
        const questionDivisionIds = getQuestionDivisionIds(question);
        return questionDivisionIds.includes(activeDivision);
      });
      setQuestions(matchedQuestions);
    }
  }, [questionsList, activeDivision]);

  const formatDateForAPI = (date) => {
    if (!date) return null;

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  };

  const submitSurveyResponses = async () => {
    setLoading(true);
    const endDate = new Date();

    const payload = {
      email,
      start_date: formatDateForAPI(startDate),
      end_date: formatDateForAPI(endDate),
      role: roleName,
      responses: answers,
      sales_leader: roleName === "Sales Leader" ? salesLeader + 1 : salesLeader,
      sales_manager:
        roleName === "Sales Manager" ? salesManager + 1 : salesManager,
      sales_professional:
        roleName === "Sales Professional"
          ? salesProfessional + 1
          : salesProfessional,
    };

    try {
      const response = await fetch(
        `${API_BASE_URL}/survey-results/survey_resullt_submit`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        }
      );

      const result = await response.json();

      if (!response.ok || !result.success) {
        throw new Error(result.message || "Failed to submit survey");
      }

      setResultSummaryData({
        Sales_Leader: result.sales_leader,
        Sales_Manager: result.sales_manager,
        Sales_Professional: result.sales_professional,
      });

      setLoading(false);
      setAnswers([]);
      setSuccessMessage(
        `Thank you for taking time to complete the survey. Your responses will be included in our final analysis and implementation plan for building a world-class sales organization`
      );
      setShowModal(true);
      setStartDate(null);

      return result;
    } catch (error) {
      console.error("Error submitting survey:", error.message);
      setLoading(false);
      return { error: error.message };
    }
  };

  const handleChangeDivision = (role, Division_Id, Division_Name) => {
    setActiveDivision(Division_Id);
    setActiveDivisionName(Division_Name);
    setRoleName(role.Role_Name);
  };

  // Check if survey has started (user has answered questions or started date is set)
  const hasSurveyStarted = () => {
    return answers.length > 0 || startDate !== null;
  };

// Updated handleChangeRole with proper same role handling
const handleChangeRole = (role) => {
  // If it's the same role, do nothing - just return
  if (role.Role_Id === activeRole) {
    return;
  }

  // If survey hasn't started, proceed directly
  if (!hasSurveyStarted()) {
    proceedWithRoleChange(role);
    return;
  }

  // If survey has started and it's a different role, show confirmation modal
  setPendingRole(role);
  setShowRoleSwitchModal(true);
};

// Alternative approach - you can also update the condition in proceedWithRoleChange
const proceedWithRoleChange = (role) => {
  // Only clear data if it's actually a different role
  if (role.Role_Id !== activeRole) {
    setAnswers([]); 
    setCompletedDivisions([]); 
    setStartDate(null);
    setSuccessMessage("");
    setShowModal(false); 
  }
  
  // Set new role data
  setActiveRole(role.Role_Id);
  setDivisions(role.Divisions);
  setActiveDivision(role.Divisions[0].Division_Id);
  setActiveDivisionName(
    [...role.Divisions].sort((a, b) => a.Division_Id - b.Division_Id)[0]
      ?.Division_Name
  );
  setRoleName(role.Role_Name);
  
  // Scroll to top for better UX (only if role actually changed)
  if (role.Role_Id !== activeRole) {
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }, 100);
  }
};
  // Handle role switch confirmation
  const handleRoleSwitchConfirm = () => {
    if (pendingRole) {
      proceedWithRoleChange(pendingRole);
    }
    setShowRoleSwitchModal(false);
    setPendingRole(null);
  };

  // Handle role switch cancellation
  const handleRoleSwitchCancel = () => {
    setShowRoleSwitchModal(false);
    setPendingRole(null);
  };

  const isValidEmail = (email) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  };

  // Updated validation logic for the new question format
  const areAllQuestionsAnswered = questions.every((question) => {
    const questionDivisionIds = getQuestionDivisionIds(question);
    const questionRoleIds = getQuestionRoleIds(question);

    return answers.some((answer) => {
      const answerMatchesDivision = questionDivisionIds.some((divId) => {
        const division = getDivision(divId)[0];
        return division && answer.division === division.Division_Name;
      });

      const answerMatchesRole = questionRoleIds.some((roleId) => {
        const role = getRole(roleId)[0];
        return role && answer.role === role.Role_Name;
      });
      return answer.question === question.Question && answerMatchesDivision;
    });
  });

  const canProceed = areAllQuestionsAnswered;

  const currentRole = roles.find((role) => role.Role_Id === activeRole);
  const divisionsn = currentRole ? currentRole.Divisions : [];
  const totalDivisions = divisionsn.length;

  useEffect(() => {
    if (divisionsn.length > 0) {
      setActiveDivision(divisionsn[0].Division_Id);
    }
  }, [currentRole]);

  const handleNext = () => {
    if (!email.trim() || !isValidEmail(email)) {
      setShowEmailError(true);
      setTimeout(() => {
        emailSectionRef.current?.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }, 100);
      return;
    }

    const currentIndex = divisionsn.findIndex(
      (div) => div.Division_Id === activeDivision
    );
    if (currentIndex !== -1 && currentIndex < totalDivisions - 1) {
      setCompletedDivisions((prev) => [...prev, activeDivision]);
      setActiveDivision(divisionsn[currentIndex + 1].Division_Id);
      setActiveDivisionName(divisionsn[currentIndex + 1]?.Division_Name);

      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
      }, 100);
    }
  };

  const handleSubmit = () => {
    if (!email.trim() || !isValidEmail(email)) {
      setShowEmailError(true);
      setTimeout(() => {
        emailSectionRef.current?.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }, 100);
      return;
    }

    submitSurveyResponses();
  };

  const handleBack = () => {
    const currentIndex = divisionsn.findIndex(
      (div) => div.Division_Id === activeDivision
    );
    if (currentIndex > 0) {
      setActiveDivision(divisionsn[currentIndex - 1].Division_Id);
      setActiveDivisionName(divisionsn[currentIndex - 1]?.Division_Name);

      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
      }, 100);
    }
  };

  const handleClose = async () => {
    setShowModal(false);
    setAnswers([]);
    setActiveRole(1);

    if (roles.length > 0) {
      setRoleName(roles[0].Role_Name);
      setDivisions(roles[0].Divisions);
      setActiveDivisionName(roles[0].Divisions[0].Division_Name);
      setActiveDivision(roles[0].Divisions[0].Division_Id);
    }

    setCompletedDivisions([]);
    setStartDate(null);
    setSuccessMessage("");

    // ✅ Retain email and verification state
    setIsEmailVerified(true);
    setIsVerificationModalOpen(false);

    // ✅ Refresh survey summary data after submission
    if (email) {
      await fetchSurveyResultSummary(email);
    }

    window.scrollTo(0, 0);
  };

  return (
    <>
      <Navbar />
      <EmailVerificationModal
        isOpen={isVerificationModalOpen}
        onClose={() => setIsVerificationModalOpen(false)}
        onVerificationSuccess={handleVerificationSuccess}
        API_BASE_URL={API_BASE_URL}
      />

      <div className="survey-container" style={{ marginTop: "80px" }}>
        <div className="header">
          <div className="header-left">
            <h1 style={{ marginTop: "20px" }}>Welcome to Sales Survey</h1>
            <p>Date: {currentDate}</p>
          </div>
          <div className="header-right desktop-summary">
            <div className="summary-desktop">
              <p>
                <strong>Survey Summary -</strong> ( Sales Leader -{" "}
                {resultSummaryData?.Sales_Leader || 0}, Sales Manager -{" "}
                {resultSummaryData?.Sales_Manager || 0}, Sales Professional -{" "}
                {resultSummaryData?.Sales_Professional || 0}){" "}
              </p>
            </div>
          </div>
        </div>

        <div className="instructions">
          <p>
            <strong>INSTRUCTIONS:</strong> Please provide your email address and
            select your role (sales leader, sales manager, sales professional)
            to view and answer the relevant survey questions. You must answer
            all of the questions and then submit the survey. You can take the
            survey as many times as you want. Your responses will be recorded
            after submission, and you can review them before finalizing. Each
            attempt is independent, so previous answers will not carry over.
          </p>
          <p>
            Sales Professional = Responsible for selling the product or service,
            Sales Manager = Responsible for leading a team of sales
            professionals, Sales Leader = Responsible for leading a sales
            organization with multiple layers (sales director and above)
          </p>
        </div>

        <div className="mobile-summary">
          <div className="summary-mobile">
            <p>
              <strong>Survey Summary -</strong> ( Sales Leader -{" "}
              {resultSummaryData?.Sales_Leader || 0}, Sales Manager -{" "}
              {resultSummaryData?.Sales_Manager || 0}, Sales Professional -{" "}
              {resultSummaryData?.Sales_Professional || 0}){" "}
            </p>
          </div>
        </div>

        <div className="main-content">
          <div className="roles-container">
            <div className="roles-wrapper">
              {roles.map((role) => (
                <div
                  key={role.Role_Id}
                  className="role-item"
                  onClick={() => handleChangeRole(role)}
                >
                  <div
                    className={`role-card ${
                      activeRole === role.Role_Id ? "active" : ""
                    }`}
                  >
                    <p>{role.Role_Name}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="divisions-container">
            {divisions
              .sort((a, b) => a.Division_Id - b.Division_Id)
              .map((division) => {
                const isCompleted = completedDivisions.includes(
                  division.Division_Id
                );
                const isActive = activeDivision === division.Division_Id;

                return (
                  <div key={division.Division_Id} className="division-item">
                    <div
                      className={`division-card ${isActive ? "active" : ""} ${
                        isCompleted ? "completed" : ""
                      }`}
                    >
                      <p>{division?.Division_Name}</p>
                    </div>
                  </div>
                );
              })}
          </div>

          <div className="content-area">
            <div className="survey-header">
              <div className="section-header">
                <div>
                  <h2 className="section-title">
                    {roleName} | {divisionName}
                  </h2>
                  <p className="scale-instruction">
                    On a scale of 1 – 5 (1= strongly disagree 5 = strongly
                    agree)
                  </p>
                </div>
              </div>

              <hr className="divider" />

              <div className="questions-container">
                {questions.map((question) => (
                  <div key={question.Question_Id} className="question-item">
                    <p className="question-text">{question.Question}</p>
                    <div className="options-container">
                      {(question.New_Question
                        ? [20, 40, 60, 80, "80+", "NA"]
                        : [1, 2, 3, 4, 5, "NA"]
                      ).map((option) => {
                        // Updated logic to work with new question format
                        const questionDivisionIds =
                          getQuestionDivisionIds(question);
                        const questionRoleIds = getQuestionRoleIds(question);
                        const isSelected =
                          answers.find((item) => {
                            const divisionMatch = questionDivisionIds.some(
                              (divId) => {
                                const division = getDivision(divId)[0];
                                return (
                                  division &&
                                  item?.division === division.Division_Name
                                );
                              }
                            );
                            const roleMatch = questionRoleIds.some((roleId) => {
                              const role = getRole(roleId)[0];
                              return role && item?.role === role.Role_Name;
                            });
                            return (
                              item?.question === question.Question &&
                              divisionMatch
                            );
                          })?.response == option;
                        return (
                          <div
                            key={option}
                            onClick={() => handleSelect(question, option)}
                            className={`option-button ${
                              isSelected ? "selected" : ""
                            } ${option === "NA" ? "na" : ""}`}
                          >
                            {option}
                          </div>
                        );
                      })}
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className="footer">
              <div className="buttons-container">
                <button
                  disabled={answers.length === 0}
                  onClick={handleBack}
                  className="action-button back-button"
                >
                  Back
                </button>
                <button
                  disabled={!canProceed}
                  onClick={
                    activeDivision ===
                    divisionsn[totalDivisions - 1]?.Division_Id
                      ? handleSubmit
                      : handleNext
                  }
                  className="action-button"
                  title={
                    !canProceed ? "Please answer all questions to proceed" : ""
                  }
                >
                  {activeDivision ===
                  divisionsn[totalDivisions - 1]?.Division_Id
                    ? loading
                      ? "Loading..."
                      : "Submit Survey"
                    : "Next"}
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Success Modal */}
        {showModal && (
          <div className="modal-overlay">
            <div className="modal-content">
              <h2 className="modal-title">CONGRATULATIONS!! 🎉</h2>
              <p className="modal-message">{successMessage}</p>
              <button onClick={handleClose} className="modal-button">
                Close
              </button>
            </div>
          </div>
        )}

        {/* Role Switch Confirmation Modal */}
        {showRoleSwitchModal && (
          <div className="modal-overlay" style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 1000
          }}>
            <div className="modal-content" style={{
              backgroundColor: 'white',
              padding: '10px 20px 30px 20px',
              borderRadius: '8px',
              maxWidth: '500px',
              width: '90%',
              textAlign: 'center',
              boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
            }}>
              <h2 className="modal-titles">Need Confirmation</h2>
              <p className="modal-message">
                You have already started answering questions for the current role. 
                Do you want to proceed with switching to "{pendingRole?.Role_Name}"? 
                <br/><br/>
                <strong style={{color: '#dc3545'}}>Warning:</strong> All your previous answers will be removed and you'll start fresh with the new role.
              </p>
              <div className="modal-buttons" style={{
                display: 'flex',
                justifyContent: 'center',
                gap: '15px',
                marginTop:"30px"
              }}>
                <button 
                  onClick={handleRoleSwitchCancel} 
                  className="modal-button cancel-button"
                  style={{ 
                    backgroundColor: "#6c757d", 
                    color: 'white',
                    border: 'none',
                    padding: '12px 24px',
                    borderRadius: '4px',
                    cursor: 'pointer',
                    fontSize: '16px',
                    minWidth: '100px'
                  }}
                >
                  Cancel
                </button>
                <button 
                  onClick={handleRoleSwitchConfirm} 
                  className="modal-button confirm-button"
                >
                  OK, Proceed
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
      
      {!isEmailVerified && !isVerificationModalOpen && (
        <div
          className="survey-container"
          style={{ marginTop: "80px", textAlign: "center", padding: "50px" }}
        >
          <h2>Please verify your email to access the survey</h2>
          <button
            onClick={() => setIsVerificationModalOpen(true)}
            className="action-button"
          >
            Verify Email
          </button>
        </div>
      )}

      <SalesTologyFooter />
    </>
  );
}

export default Survey;